import { makeStyles } from "@material-ui/core";
const FTLPaginationButtonStyles = makeStyles((theme) => ({
    defaultPaginationButton: {
        transition: "none",
    },
    iconPuginationButton: {
        background: "none",
        "& svg": {
            color: theme.palette.text.secondary,
        },
        "&:hover": {
            backgroundColor: theme.palette.button.secondaryHover,
        },
        "&:active": {
            backgroundColor: theme.palette.button.secondaryPressed,
        },
        "&.Mui-disabled": {
            background: "none !important",
            "& svg": {
                color: "inherit !important",
            },
        },
    },
}));
export default FTLPaginationButtonStyles;
//# sourceMappingURL=FTLPaginationButtonStyles.styles.js.map